export default {
  methods: {
    async mixin_ShowDialog(msg) {
      let dialog = [true, msg, null];
      this.$store.dispatch("SetDialog", dialog);
      await this.until();
      return this.$store.state.Dialog.answer;
    },
    until() {
      let defaultTime = this.$store.state.Dialog.clickTime;
      const poll = (resolve) => {
        if (this.$store.state.Dialog.clickTime != defaultTime) resolve();
        else setTimeout(() => poll(resolve), 400);
      };
      return new Promise(poll);
    },
  },
};
